import { formatCurrency } from "../utils";

type ExpensesFilteredTotalSectionProps = {
	totalAmount: number;
	expenseCount: number;
};

export function ExpensesFilteredTotalSection({
	totalAmount,
	expenseCount,
}: ExpensesFilteredTotalSectionProps) {
	return (
		<section
			aria-labelledby="total-filtrado-heading"
			className="rounded-xl border border-border-primary bg-white p-5 shadow-xs"
		>
			<div className="flex flex-col gap-1">
				<div className="flex flex-wrap items-center justify-between gap-x-4 gap-y-1">
					<h3
						className="font-semibold text-primary text-sm leading-5"
						id="total-filtrado-heading"
					>
						Total filtrado
					</h3>
					<p className="min-w-0 break-words font-semibold text-lg text-primary leading-7">
						{formatCurrency(totalAmount)}
					</p>
				</div>
				<p className="text-secondary text-xs leading-4">
					{expenseCount === 1 ? "1 despesa" : `${expenseCount} despesas`}
				</p>
			</div>
		</section>
	);
}
